import React from "react";
import { FormConfiguration } from "../../FormConfiguration";
import { FormRuntime } from "../../FormRuntime";
import { MultiInlineTextEditFormControl } from "../Web/MultiInlineTextEditFormControl";
import { XColumnContainer, XColumnContainerColumn } from "../../Containers/XColumnContainer";
import { LabelFormControl } from "../Web/LabelFormControl";
import { ExecutionData } from "../../../rule-engine-core/Common/Data/ExecutionData/ExecutionData";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";

function getUI(): { form: FormConfiguration } {
    let ui = new FormConfiguration();
    let container = new XColumnContainer();
    let col = new XColumnContainerColumn();

    container.add(col);
    ui.add(container);

    let label = new LabelFormControl();
    label.text = "MultiInline Text Edit";
    col.add(label);

    let InlineTextEdit = new MultiInlineTextEditFormControl();
    InlineTextEdit.placeholderText = "h1";
    InlineTextEdit.type = "h1";
    InlineTextEdit.valueName = "value";
    InlineTextEdit.requiredOnAllOutcomes = false;
    col.add(InlineTextEdit);

    InlineTextEdit = new MultiInlineTextEditFormControl();
    InlineTextEdit.placeholderText = "h2";
    InlineTextEdit.type = "h2";
    InlineTextEdit.valueName = "value";
    InlineTextEdit.requiredOnAllOutcomes = false;
    col.add(InlineTextEdit);

    InlineTextEdit = new MultiInlineTextEditFormControl();
    InlineTextEdit.placeholderText = "h3";
    InlineTextEdit.type = "h3";
    InlineTextEdit.valueName = "value";
    InlineTextEdit.requiredOnAllOutcomes = false;
    col.add(InlineTextEdit);

    InlineTextEdit = new MultiInlineTextEditFormControl();
    InlineTextEdit.placeholderText = "h4";
    InlineTextEdit.type = "h4";
    InlineTextEdit.valueName = "value";
    InlineTextEdit.requiredOnAllOutcomes = false;
    col.add(InlineTextEdit);

    InlineTextEdit = new MultiInlineTextEditFormControl();
    InlineTextEdit.placeholderText = "h5";
    InlineTextEdit.type = "h5";
    InlineTextEdit.valueName = "value";
    InlineTextEdit.requiredOnAllOutcomes = false;
    col.add(InlineTextEdit);

    InlineTextEdit = new MultiInlineTextEditFormControl();
    InlineTextEdit.placeholderText = "h6";
    InlineTextEdit.type = "h6";
    InlineTextEdit.valueName = "value";
    InlineTextEdit.requiredOnAllOutcomes = false;
    col.add(InlineTextEdit);

    InlineTextEdit = new MultiInlineTextEditFormControl();
    InlineTextEdit.placeholderText = "subtitle1";
    InlineTextEdit.type = "subtitle1";
    InlineTextEdit.valueName = "value";
    InlineTextEdit.requiredOnAllOutcomes = false;
    col.add(InlineTextEdit);

    InlineTextEdit = new MultiInlineTextEditFormControl();
    InlineTextEdit.placeholderText = "subtitle2";
    InlineTextEdit.type = "subtitle2";
    InlineTextEdit.valueName = "value";
    InlineTextEdit.requiredOnAllOutcomes = false;
    col.add(InlineTextEdit);

    InlineTextEdit = new MultiInlineTextEditFormControl();
    InlineTextEdit.placeholderText = "body1";
    InlineTextEdit.type = "body1";
    InlineTextEdit.valueName = "value";
    InlineTextEdit.requiredOnAllOutcomes = false;
    col.add(InlineTextEdit);

    InlineTextEdit = new MultiInlineTextEditFormControl();
    InlineTextEdit.placeholderText = "caption";
    InlineTextEdit.type = "caption";
    InlineTextEdit.valueName = "value";
    InlineTextEdit.requiredOnAllOutcomes = false;
    col.add(InlineTextEdit);

    InlineTextEdit = new MultiInlineTextEditFormControl();
    InlineTextEdit.placeholderText = "button";
    InlineTextEdit.type = "button";
    InlineTextEdit.valueName = "value";
    InlineTextEdit.requiredOnAllOutcomes = false;
    col.add(InlineTextEdit);

    InlineTextEdit = new MultiInlineTextEditFormControl();
    InlineTextEdit.placeholderText = "overline";
    InlineTextEdit.type = "overline";
    InlineTextEdit.valueName = "value";
    InlineTextEdit.requiredOnAllOutcomes = false;
    col.add(InlineTextEdit);

    return { form: ui };
}

export const MultiInlineTextEditStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Multi Inline Text Edit",
        "Default",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let ctf = c as MultiInlineTextEditFormControl;
                if (ctf) {
                    ctf.hintText = "hint text";
                }
            }
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Multi Inline Text Edit",
        "With Hint",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let ctf = c as MultiInlineTextEditFormControl;
                if (ctf) {
                    ctf.placeholderText = "placeholder text";
                }
            }
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Multi Inline Text Edit",
        "With Placeholder",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let ctf = c as MultiInlineTextEditFormControl;
                if (ctf) {
                    ctf.requiredOnAllOutcomes = true;
                }
            }
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Multi Inline Text Edit",
        "With Validation",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let data = new ExecutionData();
            data.values["value"] = "text value";
            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Multi Inline Text Edit",
        "With Value",
    ),
];
